import { z } from 'zod';
const EmailMessageSchema = z.object({
    id: z.number(),
    subject: z.string(),
    from: z.string(),
    to: z.array(z.string()),
    text: z.optional(z.string()),
    html: z.optional(z.string())
});
const ShowTestEmailLogInboundSchema = z
    .object({
    emailMessages: z.array(EmailMessageSchema)
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'show_test_email_log',
    ...rest
}));
export const SHOW_TEST_EMAIL_LOG_PAYLOAD_DEFINITION = {
    zodSchema: ShowTestEmailLogInboundSchema
};
